












































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import BaseTable from "../components/common/BaseTable.vue";
import AxiosMixin from "../mixins/axiosMixin";
import {
  HeaderWidthItem,
  SearchCondition,
  ObjectId,
  dateJp,
  nextMonth
} from "@/types";
import { Ref } from "vue-property-decorator";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    BaseTable,
    LoadingDialog
  }
})
export default class CareCsv extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  private targetYM: string = nextMonth(); //国保請求月

  private mediaClass = 7; //媒体区分

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "is_printed",
      text: "出力済",
      width: "86px"
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px"
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px"
    },
    {
      value: "name",
      text: "氏名",
      width: "140px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px"
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px"
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "160px"
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "148px"
    }
  ];

  private tableItems: object[] = [];

  private alphabet = "a".charCodeAt(0);

  private z = "z".charCodeAt(0);

  mounted() {
    this.updateData(this.baseTable.getSearchCondition());
  }

  private updateData(searchCondition: SearchCondition) {
    this.postJsonCheck(
      window.base_url + "/api/office/care/csv/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        only_not_printed: searchCondition.isDone,
        insurance_no: searchCondition.insuranceNo,
        insurance_name: searchCondition.insuranceName,
        ibow_id: searchCondition.userCode,
        furigana: searchCondition.userKana,
        insured_no: searchCondition.userInsNo
      },
      res => {
        this.tableItems = res.data.csvs;
        this.baseTable.refreshSelectItem();
        this.$nextTick(() => {
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search(searchCondition: SearchCondition) {
    this.updateData(searchCondition);
  }

  private done(objectIds: ObjectId[]) {
    const map = new Map<string, number[]>();
    objectIds.forEach(objectId => {
      if (map.has(objectId.yearmonth)) {
        const ids = map.get(objectId.yearmonth);
        ids?.push(objectId.id);
      } else {
        map.set(objectId.yearmonth, [objectId.id]);
      }
    });
    map.forEach((value, key) => {
      this.postJsonBlobResCheck(
        window.base_url + "/api/office/care/csv/output",
        {
          ids: value,
          media_class: String(this.mediaClass),
          target_month: this.targetYM.replace("-", "")
        },
        res => {
          const blob = new Blob([res.data]);
          const a = document.createElement("a");
          const now = dateJp(new Date());
          const nowMonth = now.substr(2, 2) + now.substr(5, 2);
          let prefix = "i";
          if (this.mediaClass == 2) {
            prefix = "m";
          } else if (this.mediaClass == 4) {
            prefix = "f";
          }
          a.download = `${prefix}${nowMonth}${String.fromCharCode(
            this.alphabet
          )}.csv`;
          a.href = URL.createObjectURL(blob);
          a.click();
          if (this.alphabet >= this.z) {
            this.alphabet = "a".charCodeAt(0);
          } else {
            this.alphabet += 1;
          }
        }
      );
    });
  }

  private checked(objectIds: ObjectId[]) {
    const ids = objectIds.map(objectId => objectId.id);
    this.postJsonCheck(
      window.base_url + "/api/office/care/csv/checked",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "◯";
        });
      }
    );
  }

  private cancel(objectIds: ObjectId[]) {
    const ids = objectIds.map(objectId => objectId.id);
    this.postJsonCheck(
      window.base_url + "/api/office/care/csv/cancel",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "";
        });
      }
    );
  }
}
